



































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ActiveSurveyForm } from "@/api";
import FiveStarForm from "@/components/five_star/FiveStarForm.vue";
import SurveyForm from "@/views/survey/form/Form.vue";
import OptionsSurvey from "@/views/survey/form/OptionsSurvey.vue";

@Component({
  components: {
    SurveyForm,
    FiveStarForm,
    OptionsSurvey,
  },
})
export default class StartSurvey extends Vue {
  @Prop() readonly dispatchType!: string;
  dialog = false;
  callType = this.dispatchType;
  surveyDialog = false;
  surveyOptionDialog = false;
  counter = 0;
  dischargeForm!: ActiveSurveyForm;
  admissionForm!: ActiveSurveyForm;

  async created() {
    this.callType = this.dispatchType;
    await this.$store.dispatch("survey/fetchActiveSurveyForm");
  }

  recognize() {
    this.surveyDialog = !this.surveyDialog;
    this.dialog = !this.dialog;
  }

  startAdmissionSurvey() {
    this.counter++;
    this.callType = "admission";
    this.surveyOptionDialog = !this.surveyOptionDialog;
    this.surveyDialog = !this.surveyDialog;
  }

  startDischargeSurvey() {
    this.counter++;
    this.callType = "discharge";
    this.surveyOptionDialog = !this.surveyOptionDialog;
    this.surveyDialog = !this.surveyDialog;
  }

  startSatisfactionSurvey() {
    this.counter++;
    this.callType = "satisfaction";
    this.surveyOptionDialog = !this.surveyOptionDialog;
    this.surveyDialog = !this.surveyDialog;
  }

  complete() {
    this.$emit("complete", this.callType);
  }
}
